import * as React from 'react';
import { Badge, Button, Card, Col, Grid, Row, User } from '@nextui-org/react';
import { useRouter } from 'next/router';
import { ROUTES } from '@src/config/constants';
import {
  GetClientsQuery,
  useGetClientUnsetStoriesQuery,
} from '@src/generated/hooks';

interface ClientListItemProps {
  client: GetClientsQuery['clients'][0];
}

/**
 * @name ClientListItem
 * @description tbd...
 */
export function ClientListItem(props: ClientListItemProps) {
  const { client } = props;

  // Hooks
  const router = useRouter();

  // Setup
  const clientInitial = client.name[0].toUpperCase();
  const handlesTotal = client.igHandles.length ?? 0;
  const handleIds = client.igHandles.map((handle) => handle.id);

  // GraphQL
  const { data, loading } = useGetClientUnsetStoriesQuery({
    variables: {
      handleIds,
    },
  });

  // More setup
  const unsetStoriesTotal = data?.igAssets?.length ?? 0;

  // Handlers
  const onViewApproved = (clientName: string) => {
    router.push(`${ROUTES.feed}?clients=${clientName}&statuses=APPROVED`);
  };

  const onViewNew = (clientName: string) => {
    router.push(`${ROUTES.feed}?clients=${clientName}&statuses=UNSET`);
  };

  const onEditClient = (clientId: string) => {
    router.push(`${ROUTES.clientsEdit}/${clientId}`);
  };

  return (
    <Grid key={client.id} xs={12} sm={4}>
      <Card
        css={{ w: '100%' }}
        isHoverable
        isPressable
        variant="bordered"
        onPress={() => onEditClient(client.id)}
      >
        <Card.Header>
          <User
            name={client.name}
            text={clientInitial}
            squared
            description={`${handlesTotal} handles`}
          />
        </Card.Header>

        <Card.Divider />

        <Card.Footer>
          <Row justify="space-between" gap={0.5}>
            <Col span={6}>
              <Button
                flat
                auto
                color="success"
                css={{ w: 'stretch' }}
                onPress={() => onViewApproved(client.name)}
              >
                Accepted
              </Button>
            </Col>

            <Col span={6}>
              <Badge
                content={unsetStoriesTotal}
                color="error"
                variant={loading ? 'points' : 'default'}
              >
                <Button
                  auto
                  onPress={() => onViewNew(client.name)}
                  css={{ w: 'stretch' }}
                >
                  New Stories
                </Button>
              </Badge>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Grid>
  );
}
